// Shared status dropdown for the staff listings (Exhibits / Zones / Exhibitions).
// Reveals archived / purged records without cluttering the default working view.
// Native <select> to match AuditFilters and stay usable from the .jsx dashboards.

import type { FC } from "react";
import { LIST_STATUS_OPTIONS, type ListStatus } from "@shared/api/listStatus";

export interface StatusFilterProps {
  value: ListStatus;
  onChange: (value: ListStatus) => void;
  testId?: string;
}

const StatusFilter: FC<StatusFilterProps> = ({
  value,
  onChange,
  testId = "status-filter",
}) => (
  <label className="flex items-center gap-2 text-sm text-muted-foreground">
    <span>Status</span>
    <select
      className="block h-9 rounded-md border border-input bg-background px-2 text-sm"
      value={value}
      onChange={(e) => onChange(e.target.value as ListStatus)}
      data-testid={testId}
    >
      {LIST_STATUS_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </label>
);

export default StatusFilter;
